
import {
    INCREMENT,
    DECREMENT
} from "../constants/testConstant.js";

export const counter = (state = 0, acttion) => {
    switch (acttion.type) {
        case INCREMENT:
            return state + 1

        case DECREMENT:
            if (state === 0) {
                return 0
            }
            return state - 1

        default:
            return state
    }

}

